import React from 'react';

import {
  Breakpoints,
  TextCustom,
  TextAppearance,
  TextSize,
  TextWeight,
  TextColor,
  TextLineHeight,
} from '@vw-marketing/us-components';

import { StyledInformationBoxContainer } from './styled';

interface InformationBoxProps {
  title: string;
  description?: string;
}

export const InformationBox = ({ title, description }: InformationBoxProps) => {
  return (
    <StyledInformationBoxContainer>
      <TextCustom
        appearance={TextAppearance.label150}
        style={{
          [Breakpoints.default]: {
            fontSize: TextSize.TextSize20,
            fontWeight: TextWeight.bold,
            color: TextColor.primary,
            lineHeight: TextLineHeight.TextLineHeight32,
          },
          [Breakpoints.b1920]: {
            fontSize: TextSize.TextSize24,
            fontWeight: TextWeight.bold,
            color: TextColor.primary,
            lineHeight: TextLineHeight.TextLineHeight36,
          },
        }}
      >
        {title}
      </TextCustom>
      <TextCustom
        appearance={TextAppearance.copy100}
        style={{
          [Breakpoints.default]: {
            fontSize: TextSize.TextSize14,
            fontWeight: TextWeight.light,
            color: TextColor.primary,
            lineHeight: TextLineHeight.TextLineHeight24,
          },
          [Breakpoints.b1920]: {
            fontSize: TextSize.TextSize16,
            fontWeight: TextWeight.light,
            color: TextColor.primary,
            lineHeight: TextLineHeight.TextLineHeight24,
          },
        }}
      >
        {description || ''}
      </TextCustom>
    </StyledInformationBoxContainer>
  );
};
